import {CustomerSubscriptionModuleConfiguration} from "./customer-subscription.module-configuration";
import {
    CustomerSubscriptionStatusesComponent
} from "./component/customer-subscriptions-statuses/customer-subscription-statuses.component";
import {CustomerSubscriptionsService} from "./service/customer-subscriptions.service";
import {SubscriptionService} from "../utils/names/serviceNames";

CustomerSubscriptionModuleConfiguration.createNewModule()
    .component('customerSubscriptions', CustomerSubscriptionStatusesComponent.instance)
    .service(SubscriptionService, CustomerSubscriptionsService.instance);